import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const HubDBIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "HubDB",
    children: /*#__PURE__*/_jsx("path", {
      d: "M28.91 9.65c0 4.22-5.78 7.65-12.91 7.65S3.08 13.87 3.08 9.65 8.86 2 16 2s12.91 3.42 12.91 7.65M16 25.56c-5.46 0-10.12-1.82-12.69-4.58-.13.41-.21.88-.22 1.37C3.09 26.57 8.87 30 16 30s12.91-3.42 12.91-7.65c0-.49-.08-.96-.23-1.4v.03c-2.58 2.76-7.24 4.58-12.7 4.58Zm0-6.35c-5.46 0-10.12-1.82-12.69-4.58-.13.41-.21.88-.22 1.37 0 4.22 5.78 7.65 12.91 7.65S28.91 20.23 28.91 16c0-.49-.08-.96-.23-1.4v.03c-2.58 2.76-7.24 4.58-12.7 4.58Z"
    })
  }));
};